import { BatchEventsManager } from "@faire/web--source/common/batch-events/BatchEventsManager";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { getFaireDirectBrandAliasFromQueryParam } from "@faire/web--source/common/routes/faire-direct/getFaireDirectBrandAliasFromQueryParam";
import { splitHostname } from "@faire/web--source/common/splitHostname";
import { IUserEvent } from "@faire/web-api--source/indigofair/data/IUserEvent";
import debug from "debug";
var logEvent = debug("IF:EVENT");
/**
 * @deprecated track events using PETE instead. https://faire.com/pete
 * @trackfunction
 */ export var trackEvent = function(eventPath) {
    var prependPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var joinedPath = function() {
        if (Array.isArray(eventPath)) {
            return eventPath.join("/");
        }
        return eventPath;
    }();
    var fullEventPath = "".concat(prependPathname ? getLocationOrThrow().pathname.replace(/\/$/, "") : "", "/").concat(joinedPath.replace(/^\//, ""));
    logEvent(fullEventPath);
    var subdomain;
    try {
        var faireDirectBrandAlias = getFaireDirectBrandAliasFromQueryParam(getLocationOrThrow().search);
        if (faireDirectBrandAlias) {
            subdomain = faireDirectBrandAlias;
        } else {
            var _splitHostname;
            subdomain = (_splitHostname = splitHostname(getLocationOrThrow().hostname)) === null || _splitHostname === void 0 ? void 0 : _splitHostname.subdomain;
        }
    } catch (_) {
    /* ignore */ }
    var event = IUserEvent.build({
        client_created_at: Date.now(),
        path: fullEventPath,
        subdomain: subdomain
    });
    return BatchEventsManager.get().enqueueEvent(event);
};
/**
 * @deprecated track events using PETE instead. https://faire.com/pete
 * @trackfunction
 */ export var trackEventOnClick = function(eventPath) {
    var prependPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function() {
        trackEvent(eventPath, prependPathname);
    };
};
